const pause = () => (
  <>
    <path d="M9 6.5a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0zM14 6.5a.5.5 0 0 1 1 0v11a.5.5 0 0 1-1 0z"></path>
  </>
)
export default pause
